// Z-sıra = layout.elements dizi sırası (sonraki = üstte). Saf reorder yardımcıları.
// Bir veya birden çok seçili id'yi diziye göre taşır.

function partition(elements, ids) {
  const set = new Set(ids);
  const sel = elements.filter((e) => set.has(e.id));
  const rest = elements.filter((e) => !set.has(e.id));
  return { sel, rest };
}

export function toFront(elements, ids) {
  const { sel, rest } = partition(elements, ids);
  return [...rest, ...sel];
}

export function toBack(elements, ids) {
  const { sel, rest } = partition(elements, ids);
  return [...sel, ...rest];
}

// Seçimi bir adım yukarı (üste doğru) taşır.
export function bringForward(elements, ids) {
  const set = new Set(ids);
  const arr = [...elements];
  for (let i = arr.length - 2; i >= 0; i--) {
    if (set.has(arr[i].id) && !set.has(arr[i + 1].id)) {
      [arr[i], arr[i + 1]] = [arr[i + 1], arr[i]];
    }
  }
  return arr;
}

// Seçimi bir adım aşağı (alta doğru) taşır.
export function sendBackward(elements, ids) {
  const set = new Set(ids);
  const arr = [...elements];
  for (let i = 1; i < arr.length; i++) {
    if (set.has(arr[i].id) && !set.has(arr[i - 1].id)) {
      [arr[i], arr[i - 1]] = [arr[i - 1], arr[i]];
    }
  }
  return arr;
}

// Katman listesinde sürükle-bırak: dragId'yi targetId'nin önüne taşı (diziyi yeniden sırala).
export function reorderTo(elements, dragId, targetId) {
  if (dragId === targetId) return elements;
  const arr = [...elements];
  const from = arr.findIndex((e) => e.id === dragId);
  const to = arr.findIndex((e) => e.id === targetId);
  if (from < 0 || to < 0) return elements;
  const [moved] = arr.splice(from, 1);
  const insertAt = arr.findIndex((e) => e.id === targetId);
  arr.splice(insertAt, 0, moved);
  return arr;
}
